/** Accept "." or "," while typing; normalize display to ",". */
export function sanitizeDecimalInput(raw) {
  let value = String(raw ?? "").replace(/\./g, ",");
  value = value.replace(/[^\d,]/g, "");
  const parts = value.split(",");
  if (parts.length > 2) {
    value = `${parts[0]},${parts.slice(1).join("")}`;
  }
  return value;
}

export function formatDecimalWithComma(value) {
  if (value == null || value === "") return "";
  const num = Number(value);
  if (!Number.isFinite(num)) return String(value);
  return String(num).replace(".", ",");
}

export function parseDecimalInput(input) {
  const trimmed = String(input ?? "").trim();
  if (trimmed === "" || trimmed === ",") return null;
  const normalized = trimmed.replace(",", ".");
  const value = Number(normalized);
  if (!Number.isFinite(value) || value < 0) return NaN;
  return value;
}

export function isValidDecimalInput(input) {
  const trimmed = String(input ?? "").trim();
  if (trimmed === "" || trimmed === ",") return true;
  if (!/^\d+(,\d*)?$/.test(trimmed)) return false;
  return !Number.isNaN(parseDecimalInput(trimmed));
}
